
const realData = [
  "Avg immigration firm: 60 cases/mo, 3 hrs/form",
  "Admin costs: c. £120K/year for a small firm",
  "Xeni already reduces form time to minutes",
  "Gross margin for typical firm: ~25%",
];

const seedProves = [
  "Acquire 1-2 firms → deploy COSX + Xeni",
  "Measure: caseload ↑, admin cost ↓, margin ↑",
  "Target: gross margin from 25% → 50-55%",
  "Generate real before/after P&L data",
];

const timeline = [
  { stage: "Angel (Done)", detail: "Pre-revenue · 2 products · Dec 2025", valuation: "£5M", active: false },
  { stage: "Seed (Now)", detail: "£60K ARR · 3 countries · Q2 2026", valuation: "£7.5M", active: true },
  { stage: "Series A", detail: "£2-3M ARR · 12-15× multiple · Q1 2027", valuation: "£30-50M", active: false },
];

export function NewRoadmapSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          From seed to scale
        </h2>
      </div>

      <div className="flex flex-row gap-6 mb-4">
        {/* Left: What we're proving */}
        <div className="flex-1">
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            What we&apos;re proving with seed
          </div>
          <div className="mb-4">
            <div className="text-[11px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-wider mb-2">
              What we know (real data):
            </div>
            <ul className="space-y-1">
              {realData.map((d) => (
                <li key={d} className="flex items-start gap-2 text-[12px] text-[var(--color-fg-secondary)]">
                  <span className="w-1 h-1 rounded-full bg-[var(--color-fg-tertiary)] mt-[6px] shrink-0" />
                  {d}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-[11px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] uppercase tracking-wider mb-2">
              What seed capital proves:
            </div>
            <ul className="space-y-1">
              {seedProves.map((d) => (
                <li key={d} className="flex items-start gap-2 text-[12px] text-[var(--color-fg-secondary)]">
                  <span className="w-1 h-1 rounded-full bg-[var(--color-accent)] mt-[6px] shrink-0" />
                  {d}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right: Investor growth path with connected timeline */}
        <div className="flex-1">
          <div className="text-[12px] font-[family-name:var(--font-mono)] font-bold text-[var(--color-accent)] uppercase tracking-[0.1em] mb-4 pb-2 border-b border-[var(--color-border)]">
            Investor growth path
          </div>
          <div className="pl-5">
            <div className="flex flex-col gap-6">
              {timeline.map((t, i) => (
                <div key={t.stage} className="flex items-start gap-3 relative">
                  <div className={`absolute left-[-17px] top-[5px] w-2.5 h-2.5 rounded-full shrink-0 z-[1] ${t.active ? "bg-[var(--color-accent)]" : "bg-[var(--color-fg-tertiary)]"}`} />
                  {i < timeline.length - 1 && <div className="absolute left-[-13px] top-[15px] bottom-[-28px] w-px bg-[var(--color-border)]" />}
                  <div>
                    <div className="text-[12px] font-medium">{t.stage}</div>
                    <div className="text-[11px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)]">{t.detail}</div>
                    <div className="text-[18px] font-light tracking-tight mt-1 font-[family-name:var(--font-heading)]">{t.valuation}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <p className="text-[11px] text-[var(--color-fg-tertiary)] mt-4 leading-relaxed">
            Series A logic: 10-20 acquired firms × £150-200K revenue each = £2-3M ARR. At 12-15× ARR (standard for AI vertical SaaS), valuation reaches £30-50M.
          </p>
        </div>
      </div>

      {/* Bottom summary */}
      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Seed → Series A: <strong className="text-[var(--color-fg)] font-medium">4-7× valuation uplift in 12 months</strong>
        </p>
      </div>
    </div>
  );
}
